"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") {
		for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: () => from[key],
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useLinkTo_exports = {};
__export(useLinkTo_exports, { useLinkTo: () => useLinkTo });
module.exports = __toCommonJS(useLinkTo_exports);
var import_getPathFromState_mods = require("../fork/getPathFromState-mods");
var import_matchers = require("../router/matchers");
var import_router = require("../router/router");
function useLinkTo(props) {
	var { linkTo } = (0, import_router.useOneRouter)();
	var onPress = function(e) {
		var event = props.replace ? "REPLACE" : "PUSH";
		var shouldHandle = false;
		shouldHandle = e ? !e.defaultPrevented : true;
		if (shouldHandle) {
			var options = props.mask ? { mask: { href: props.mask } } : void 0;
			linkTo(props.href, event, options);
		}
	};
	var displayHref = props.mask || props.href;
	return {
		href: (0, import_getPathFromState_mods.appendBaseUrl)((0, import_matchers.stripGroupSegmentsFromPath)(displayHref) || "/"),
		role: "link",
		onPress
	};
}
//# sourceMappingURL=useLinkTo.js.map
